




export default {
  name: 'CurvedArrowLeftIcon',
  props: {
    color: {
      type: String,
      default: '#B6BEC7'
    }
  }
}
